<template>
  <section>
    <h3 class="h-title">提交文件-业务文件</h3> 
    <el-form class="e-form f-b" ref="cForm4" :model="cForm4" label-width="auto"  label-position="left" :rules="setpFormRules4">  
      <el-form-item class="w-70" label="消费投资服务申请书（客户-中数华链）" prop="serviceApplyFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceApplyFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceApplyFile')" 
            :on-error="handleError"
            :file-list="cForm4.serviceApplyFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="消费投资服务协议（客户-中数华链）" prop="consumerServiceProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'consumerServiceProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'consumerServiceProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm4.consumerServiceProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="推介服务协议（仲裁委-中数华链）" prop="serviceProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'serviceProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'serviceProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm4.serviceProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70 label-more-r" label="法律综合服务协议" prop="lawServiceProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'lawServiceProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'lawServiceProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm4.lawServiceProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item class="w-70 label-more" label="仲裁协议" prop="arbitrateProtocolFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'arbitrateProtocolFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'arbitrateProtocolFile')" 
            :on-error="handleError"
            :file-list="cForm4.arbitrateProtocolFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">		
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>
<script>
import baseUrl from '@/api/baseUrl.js'
export default {
    name: "step4",
    props: ["active"],
		data() {
			return {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        },      
        cForm4: {}, 
				setpFormRules4: {
          serviceApplyFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          consumerServiceProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          serviceProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          lawServiceProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          arbitrateProtocolFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ]
        },
        action: '',
        butLoading: false,
        sceneTypeText: ''
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 4) {
          window.scrollTo(0,0);
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm4 = JSON.parse(sessionStorage.setpForm);
          this.cForm4.serviceApplyFile = JSON.parse(this.cForm4.serviceApplyFile) || [];
          this.cForm4.consumerServiceProtocolFile = JSON.parse(this.cForm4.consumerServiceProtocolFile) || [];
          this.cForm4.serviceProtocolFile = JSON.parse(this.cForm4.serviceProtocolFile) || [];
          this.cForm4.lawServiceProtocolFile = JSON.parse(this.cForm4.lawServiceProtocolFile) || [];
          this.cForm4.arbitrateProtocolFile = JSON.parse(this.cForm4.arbitrateProtocolFile) || [];
        } 
      }
    },
    methods: {  
      fontData(){
        this.cForm4.serviceApplyFile = JSON.stringify(this.cForm4.serviceApplyFile||[]);
        this.cForm4.consumerServiceProtocolFile = JSON.stringify(this.cForm4.consumerServiceProtocolFile||[]);
        this.cForm4.serviceProtocolFile = JSON.stringify(this.cForm4.serviceProtocolFile||[]);
        this.cForm4.lawServiceProtocolFile = JSON.stringify(this.cForm4.lawServiceProtocolFile||[]);
        this.cForm4.arbitrateProtocolFile = JSON.stringify(this.cForm4.arbitrateProtocolFile||[]);
      },
      cSubmitForm(type) {
        if(type == '0'){
          this.butLoading = true;
          this.cForm4.status = '0'
          this.fontData()
          this.$api.consumer.addAndUpd(JSON.stringify(this.cForm4)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("保存成功");
              this.$router.go(-1);
            }     
          });
        }else{
          // 文件必填校验
          this.$refs["cForm4"].validate((valid) => {
            if ( valid ) {  
              this.fontData()
              sessionStorage.setpForm = JSON.stringify(this.cForm4);
              this.$emit('next');
            }
          })    
        }          
      },
      prev() {
        this.fontData()
        sessionStorage.setpForm = JSON.stringify(this.cForm4);
        this.$emit('prev')
      },
      handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm4, name, [{
                name: response.name,
                url: response.url
              }])
            this.$refs.cForm4.clearValidate(name)
          }else{
            this.$set(this.cForm4, name,[])
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm4, name, [])
      },
    }
	}
</script>